import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=59f44d3a&scoped=true&"
import script from "./orders.js?vue&type=script&lang=js&"
export * from "./orders.js?vue&type=script&lang=js&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=59f44d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f44d3a",
  null
  
)

export default component.exports